var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ibox " }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ibox-content" },
      [
        _c("div", { staticClass: "row" }),
        _vm._v(" "),
        _c("datatable", { attrs: { data: _vm.inters } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("Interacciones del dia")]),
      _vm._v(" "),
      _c("div", { staticClass: "ibox-tools" }, [
        _c("a", { staticClass: "collapse-link" }, [
          _c("i", { staticClass: "fa fa-chevron-up" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }